<template>
  <div class="input-label-wrap" v-if="!loading">
    <label :for="id" :class="className">
      {{ placeholder }}
    </label>
    <input
      ref="input"
      :class="className"
      :value="value"
      :placeholder="placeholder"
      :id="id"
      :title="title"
      :pattern="pattern"
      :autocomplete="autocomplete"
      :required="required"
      :type="type ? type : 'text'"
    />
  </div>
  <Spinner v-else />
</template>

<script>
import Spinner from './../components/Spinner'

export default {
  name: 'InputWithLabel',
  props: [
    'className',
    'loading',
    'value',
    'placeholder',
    'id',
    'title',
    'pattern',
    'autocomplete',
    'required',
    'type'
  ],
  data: function() {
    return {}
  },
  components: {
    Spinner: Spinner
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.input-label-wrap {
  display: flex;
  flex-direction: column;

  label {
    font-size: 13px;
    line-height: 20px;
    color: $grey-text;
    margin-bottom: 5px;
  }

  input {
    outline: 0;
    background: #ffffff;
    border: 1px solid rgba(102, 112, 128, 0.2);
    box-shadow: none;
    border-radius: 6px;
    padding: 7px 16px;
    font-size: 14px;
    line-height: 22px;
    color: $grey-text;

    &:focus,
    &:focus-visible {
      border: 1px solid $primary-color;
    }
  }
}
</style>
